import { useSweepstakes } from '../../contexts/SweepstakesContext'
import { Shield, ChevronLeft, Loader2 } from 'lucide-react'
import Button from '../ui/Button'

/**
 * Step5Terms
 * Final step: Accept terms and conditions, then submit
 */
const Step5Terms = () => {
  const {
    formData,
    updateFormData,
    goToPreviousStep,
    submitForm,
    isSubmitting,
    errors
  } = useSweepstakes()

  const handleBack = () => {
    goToPreviousStep()
  }

  const handleSubmit = async () => {
    await submitForm()
  }

  return (
    <div className="space-y-6">
      {/* Question */}
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Almost there!
        </h3>
        <p className="text-sm text-gray-600">
          Just one more step to enter the sweepstakes
        </p>
      </div>

      {/* Entry Summary */}
      <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
        <h4 className="font-semibold text-purple-900 mb-3 flex items-center">
          <Shield className="w-4 h-4 mr-2" />
          Your Entry Summary
        </h4>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Name:</span>
            <span className="font-medium text-gray-900">{formData.fullName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Email:</span>
            <span className="font-medium text-gray-900">{formData.email}</span>
          </div>
          {formData.phone && (
            <div className="flex justify-between">
              <span className="text-gray-600">Phone:</span>
              <span className="font-medium text-gray-900">{formData.phone}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-gray-600">Wedding Date:</span>
            <span className="font-medium text-gray-900">{formData.weddingDate}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Location:</span>
            <span className="font-medium text-gray-900">{formData.weddingLocation}</span>
          </div>
        </div>
      </div>

      {/* Terms Checkbox */}
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <label className="flex items-start cursor-pointer group">
          <input
            type="checkbox"
            checked={formData.termsAccepted}
            onChange={(e) => updateFormData('termsAccepted', e.target.checked)}
            className="mt-1 h-5 w-5 rounded border-gray-300 text-purple-600 focus:ring-purple-600 cursor-pointer"
          />
          <span className="ml-3 text-sm text-gray-700 leading-relaxed">
            I agree to the{' '}
            <a
              href="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 hover:text-purple-700 underline font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              Terms of Service
            </a>
            {' '}and{' '}
            <a
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 hover:text-purple-700 underline font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              Privacy Policy
            </a>
            , and consent to Love & Photos contacting me for marketing purposes, including information about photographers, packages, and special offers.
          </span>
        </label>
        {errors.termsAccepted && (
          <p className="mt-2 text-sm text-red-600">
            {errors.termsAccepted}
          </p>
        )}
      </div>

      {/* Submit Error */}
      {errors.submit && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-sm text-red-800 text-center">
            {errors.submit}
          </p>
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex gap-3 pt-4">
        <Button
          onClick={handleBack}
          className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold transition-colors"
          disabled={isSubmitting}
        >
          <ChevronLeft className="w-4 h-4 inline mr-1" />
          Back
        </Button>
        <Button
          onClick={handleSubmit}
          className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-3 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!formData.termsAccepted || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="w-4 h-4 inline mr-2 animate-spin" />
              Entering...
            </>
          ) : (
            'Enter Sweepstakes'
          )}
        </Button>
      </div>

      <p className="text-xs text-gray-500 text-center">
        By entering, you'll be automatically registered for the drawing
      </p>
    </div>
  )
}

export default Step5Terms
